import { useRef, useState } from 'react';
import { OutcomeType } from '@pages/app/rca/tabs/components/overview/create-outcome-dialog';
import useSearchParamsTyped from '@hooks/router-dom-helper-hooks';
import { useGetCaseOutcomeDetailQuery } from '@api/endpoints/case-outcome.api';
import { useGetCaseDetailQuery } from '@api/endpoints/case.api';

type SearchParams = {
  type?: OutcomeType;
};

export default function useRcaOutcome(caseId: number, outcomeId?: number) {
  const appBarRef = useRef<HTMLDivElement>(null);
  const [currentOutcomeId, setCurrentOutcomeId] = useState(outcomeId);
  const searchParams = useSearchParamsTyped<SearchParams>();
  const [type, setType] = useState<OutcomeType>(
    searchParams.type ?? OutcomeType.html
  );

  const { data: caseDetail, isLoading: loadingCaseDetail } =
    useGetCaseDetailQuery(caseId);

  const { data: outcomeDetail, isLoading: loadingOutcome } =
    useGetCaseOutcomeDetailQuery(
      { caseId, outcomeId: currentOutcomeId ?? -1 },
      { skip: currentOutcomeId == null }
    );

  const isLoading = loadingOutcome || loadingCaseDetail;

  return {
    caseDetail,
    appBarRef,
    caseId,
    type,
    outcomeId: currentOutcomeId,
    isEdit: outcomeId != null,
    setCurrentOutcomeId,
    outcomeDetail,
    isLoading,
  };
}

export type RcaOutcomeState = ReturnType<typeof useRcaOutcome>;
